/**
 * /dashboard/hiring/interviews — My interviews.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/interviews/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { InterviewsTab } from "@/components/hiring/interviews-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/interviews",
)({
  component: HiringInterviewsRoute,
});

function HiringInterviewsRoute() {
  return (
    <HiringModuleShell
      title="My interviews"
      description="Interviews assigned to you. Drop feedback after each round."
    >
      <HiringFeatureGate>
        <InterviewsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
